import {
    getContactsSuccess,
    getContactsFail,
    getContactByIdSuccess,
    getContactByIdFail,
    updateContactsSuccess,
    updateContactsFail,
    updateNotesSuccess,
    updateNotesFail,
    resetContactDetailsData,
    getSearchcontactSuccess,
    getSearchContactFail
}
    from '../constant';

export const initialState = {
    contactsData: {},
    contactsDataFail: {},
    ContactDetails: {},
    ContactDetailsFail: {}

};


export default function (state = initialState, action) {
    switch (action.type) {
        case getContactsSuccess:
            return {
                ...state,
                ContactDetails:null,
                contactsData: action.payload,
            };
        case getContactsFail:
            return {
                ...state,
                contactsDataFail: action.payload.message,
            };
            case getSearchcontactSuccess:
                return {
                    ...state,
                    ContactDetails:null,
                contactsData: action.payload,
                };
            case getSearchContactFail:
                return {
                    ...state,
                    contactsData:null,
                    contactsDataError: action.payload.message,
                };
        case getContactByIdSuccess:

            return {
                ...state,
                ContactDetails: action.payload,
            };
        case getContactByIdFail:
            return {
                ...state,
                ContactDetailsFail: action.payload.message,
            };
        case updateNotesSuccess:
            return {
                ...state,
                ContactDetails: action.payload,
            };
        case updateNotesFail:
            return {
                ...state,
                ContactDetailsFail: action.payload.message,
            };
            case updateContactsSuccess:
                return {
                    ...state,
                    ContactDetails: action.payload,
                };
            case updateContactsFail:
                
                return {
                    ...state,
                    ContactDetailsFail: action.payload.message,
                };
        case resetContactDetailsData:
            return {
                ...state,
                ContactDetails: null,
            };
        default:
            return state;
    }
}